import React from 'react';
import {
  EVBox, EVTypography,
} from '@eagleview/ev-comp-library';
import useStyles from '../Authorize.style';

const AutoProvisionFailed = () => {
  const classes = useStyles();
  return (
    <>
      <EVBox className={classes.autoProvisionBox}>
        <EVBox className={classes.autoProvisionMsg}>
          <EVTypography className={classes.msgStyle}>
            We are currently unable to provision your account with required access.
          </EVTypography>
          <EVTypography className={classes.msgStyle}>
            You can try again later or reach out to our
            <a href="https://www.eagleview.com/support/" style={{ color: '#007CAD', fontWeight: '600', textDecoration: 'none' }}> Support</a>
          </EVTypography>
        </EVBox>
      </EVBox>
    </>
  );
};

export default AutoProvisionFailed;
